import {LoadingOutlined} from "@ant-design/icons";

export default function Loader({print}) {
    return(
        <div className="loader">
        <LoadingOutlined />
        <p>{print}</p>
        </div>
    )
}